var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUseCase = function SvgIconUseCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M15.375 12.5v1.875A2.628 2.628 0 0 1 12.75 17h-7.5a2.628 2.628 0 0 1-2.625-2.625v-.488c0-1.177.96-2.137 2.138-2.137h9.862c.412 0 .75.338.75.75ZM11.625 2h-5.25c-3 0-3.75.75-3.75 3.75v5.685c.57-.503 1.32-.81 2.138-.81h9.862c.412 0 .75-.338.75-.75V5.75c0-3-.75-3.75-3.75-3.75ZM9.75 8.563H6A.567.567 0 0 1 5.437 8c0-.308.255-.563.563-.563h3.75c.307 0 .563.255.563.563a.567.567 0 0 1-.563.563ZM12 5.937H6a.567.567 0 0 1-.563-.562c0-.308.255-.563.563-.563h6c.307 0 .563.255.563.563a.567.567 0 0 1-.563.563Z"
  })));
};
export default SvgIconUseCase;